import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '../store/auth/actions';
import { LayoutDashboard, Upload, FileText, Search, Sparkles, LogOut } from 'lucide-react';
import logoCndj from '../logo-cndj.png';
import './Sidebar.css';

const navItems = [
  { path: '/espace-cndj', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { path: '/espace-cndj/numerisation', label: 'Numérisation', icon: Upload, end: false },
  { path: '/espace-cndj/decisions', label: 'Décisions', icon: FileText, end: false },
  { path: '/espace-cndj/recherche', label: 'Recherche', icon: Search, end: false },
];

interface SidebarProps {
  onNavClick?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onNavClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutRequest(navigate));
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-logo">
          <img src={logoCndj} alt="CNDJ" className="sidebar-logo-img" />
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">CNDJ</span>
            <span className="sidebar-logo-sub">Anonymisation</span>
          </div>
        </div>

        <div className="sidebar-section-label">ESPACE AGENT</div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              onClick={onNavClick}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="sidebar-bottom">
        <div className="sidebar-ia-card">
          <Sparkles size={20} className="sidebar-ia-icon" />
          <div>
            <strong>IA juridique active</strong>
            <p>Anonymisation et résumé automatique des décisions.</p>
          </div>
        </div>

        <button className="sidebar-logout" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
